
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#474747","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":"15"}},[_c('path',{attrs:{"d":"M497.008 19.271l-19.57 78.034c-19.155 65.446-86.805 111.245-164.321 111.245h-117.95C117.649 208.55 50 162.752 30.845 97.305L14.596 19.271m422.657 324.32l-11.069-37.997-47.976-87.636-3.024 1.977c-16.517 10.798-22.321 32.26-13.496 49.91l15.998 35.399.859 45.945c-39.138 21.271-37.61 56.32-37.61 56.32"}}),_c('path',{attrs:{"d":"M426.264 218.512l36.921 57.963a34.377 34.377 0 015.383 18.471v111.747c0 4.915-1.054 9.773-3.09 14.246l-33.322 73.191M426.184 174.994v130.601M87.574 174.994v134.284h261.207M286.795 335.843s-3.556 36.193 11.562 61.163c9.793 16.175 15.003 34.711 15.003 53.62v43.503m62.23-474.858c0 61.58-53.499 111.5-119.494 111.5s-119.494-49.92-119.494-111.5"}})])])
          )
        }
      }
    